import React, { useContext } from "react";
import SelectionItem from "../SelectionItem";
import ManIcon from "./images/man.png";
import WomanIcon from "./images/woman.png";
import { Dialog } from "@mui/material";
import StepControls from "../../StepControls";
import "./index.scss";
import { StepContext } from "../StepContext";
import { useTranslation } from "../../i18n";

const GenderSelect = ({
  isShow,
  onSelect,
  onClose
}) => {
  const {
    _t
  } = useTranslation();
  const {
    isPatient
  } = useContext(StepContext);
  const types = [{
    key: "man",
    img: ManIcon,
    name: _t("Мужчина")
  }, {
    key: "woman",
    img: WomanIcon,
    name: _t("Женщина")
  }];
  return /*#__PURE__*/React.createElement(Dialog, {
    onClose: onClose,
    open: isShow,
    fullScreen: true
  }, /*#__PURE__*/React.createElement("div", {
    className: "genderSelect"
  }, /*#__PURE__*/React.createElement(StepControls, {
    title: isPatient ? _t("Укажите ваш пол") : _t("Выберите пол пациента"),
    goBack: onClose
  }), /*#__PURE__*/React.createElement("div", {
    className: "genderSelect-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "genderSelect-list"
  }, types.map(el => /*#__PURE__*/React.createElement(SelectionItem, {
    key: el.key,
    isSelected: false,
    select: () => {
      onSelect(el.key);
    },
    preview: el.img,
    innerTitle: el.name,
    disabled: el.comingSoon,
    selectText: el.comingSoon
  }))))));
};

export default GenderSelect;